function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { placeHolderShimmer } from '../../../styles/keyFrames';
var StyledRow = /*#__PURE__*/styled.div.withConfig({
  displayName: "Row__StyledRow",
  componentId: "sc-16jina5-0"
})(["width:100%;height:", ";margin:0 0 ", " 0;animation-name:", ";animation-duration:1.25s;animation-fill-mode:forwards;animation-iteration-count:infinite;animation-timing-function:linear;background:linear-gradient(to right,#eeeeee 10%,#dddddd 18%,#eeeeee 33%);background-size:100vw 104px;"], function (props) {
  return props.thick ? '3rem' : '1rem';
}, function (_ref) {
  var noMargin = _ref.noMargin,
    theme = _ref.theme;
  return noMargin ? '0' : theme.spacing.sp8;
}, placeHolderShimmer);
var Row = function Row(_ref2) {
  var noMargin = _ref2.noMargin,
    thick = _ref2.thick,
    style = _ref2.style;
  return /*#__PURE__*/React.createElement(StyledRow, {
    thick: thick,
    style: _objectSpread({}, style),
    noMargin: noMargin
  });
};
Row.defaultProps = {
  noMargin: false,
  thick: false,
  style: {}
};
Row.propTypes = {
  noMargin: PropTypes.bool,
  thick: PropTypes.bool,
  style: PropTypes.shape({
    width: PropTypes.string
  })
};
export default Row;